import Box from '@mui/material/Box';
import { styled, useTheme } from '@mui/material/styles';
import { useMemo } from 'react';
import { drawerWidth, mainHeaderHeight } from 'theme/constants';
import { UserResponseViewModel } from 'types/user';

interface Props {
    open?: boolean;
    user: UserResponseViewModel | null;
    children: React.ReactNode;
}

export const Main = ({ open, user, children }: Props) => {
    const theme = useTheme();

    const styles = useMemo(
        () => ({
            flexGrow: 1,
            transition: theme.transitions.create('margin', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            ...(open && {
                transition: theme.transitions.create('margin', {
                    easing: theme.transitions.easing.easeOut,
                    duration: theme.transitions.duration.enteringScreen,
                }),
                marginLeft: 0,
            }),
            height: `calc(100vh - ${mainHeaderHeight}px)`,
            overflow: 'auto',
        }),
        [open, user],
    );

    return (
        <Box component="main" sx={styles}>
            {children}
        </Box>
    );
};
